<div class="tab-container">
    <lib-button [cssType]="'btn-secondary'" [text]="'Request Loss Runs'" [size]="'small'"
        (click)="openRequestLossRunsModal()"></lib-button>
    <lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
</div>